export default __webpack_public_path__ + "static/media/gamepad.6b56a811.svg";